export default __webpack_public_path__ + "static/media/logo-light.be1e4c7f.png";